const findLookupId = (options, option) => {
    let o = options.filter(l => l.label === option);
    return o.length ? o[0].value : -1;
}

export { findLookupId };
